export default "__VITE_ASSET__XCSZfcir__"